import gql from 'graphql-tag';
import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';
import { QUERY_ASSETS, AssetImageSubtype } from 'src/modules/assets';

export const QUERY_PRODUCT_DETAILS = gql`
  query ProductDetails(
    $slug: String!
  ) {
    products(where: { slug: $slug }, limit: 1) {
      id
      pim_id
      name_en
      name_de
      slug
      description_en
      description_de
      meta_title_en
      meta_title_de
      meta_description_en
      meta_description_de

      similar_products {
        id
        name_en
        name_de
        slug
        ranking
        product_categories {
          id
          slug
        }
        product_series {
         plp_display
          designer {
            name
          }
        }
        assets(where: {subtype: "${AssetImageSubtype.Cutout}"}, sort: "sorting:asc", limit: 1) {
        # assets(where: {subtype: "${AssetImageSubtype.Preview}"}) {
          subtype
          file {
            url
            alternativeText
            # width
            # height
          }
        }
      }

      product_variants {
        id
      }

      product_categories {
        id
        slug
        name_en
        name_de
      }
      product_series {
        id
        slug
        name_en
        name_de
        plp_display
        designer {
          id
          name
          description_en
          description_de
          slug
          assets(where: { subtype: "picture.personPortrait." }, limit: 1) {
            ...assetsFields
          }
        }
      }
      product_details_overlay {
        ...dynamicZone
      }
      dynamic_content {
        ...dynamicZone
        ... on ComponentTemplateS {
          image {
            caption_en
            caption_de
            image {
              url
            }
            products {
              slug
              name_en
              name_de
              product_categories(sort: "ranking:asc", limit: 1) {
                slug
              }
            }
          }
          text {
            body_text_en
            body_text_de
          }
          gallery {
            images {
              image {
                url
              }
              caption_de
              caption_en
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
          }
        }

        ... on ComponentTemplateM {
          image {
            caption_en
            caption_de
            image {
              url
            }
            products {
              slug
              name_en
              name_de
              product_categories(sort: "ranking:asc", limit: 1) {
                slug
              }
            }
          }
          text_top {
            body_text_en
            body_text_de
          }
          gallery {
            images {
              image {
                url
              }
              caption_en
              caption_de
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
          }

          side_images {
            image1 {
              caption_en
              caption_de
              image {
                url
                width
                height
              }
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
            image2 {
              caption_en
              caption_de
              image {
                url
                width
                height
              }
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
          }
          text_bottom {
            body_text_en
            body_text_de
          }
        }

        ... on ComponentTemplateL {
          image {
            caption_en
            caption_de
            image {
              url
            }
            products {
              slug
              name_en
              name_de
              product_categories(sort: "ranking:asc", limit: 1) {
                slug
              }
            }
          }
          text_top {
            body_text_en
            body_text_de
          }
          gallery {
            images {
              image {
                url
              }
              caption_en
              caption_de
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
          }
          quote {
            quote_en
            quote_de
            author_name
          }
          text_image {
            id
            title_En: title_en
            title_De: title_de
            label_en
            subline_en
            label_de
            subline_de
            image_position
            image {
              image {
                url
                caption
              }
              caption_en
              caption_de
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
            button {
              text_en
              text_de
              url
              external_link
              isButton: button
              overlay
              download {
                url
              }
            }
          }
          side_images {
            image1 {
              caption_en
              caption_de
              image {
                url
                width
                height
              }
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
            image2 {
              caption_en
              caption_de
              image {
                url
                width
                height
              }
              products {
                slug
                name_en
                name_de
                product_categories(sort: "ranking:asc", limit: 1) {
                  slug
                }
              }
            }
          }
          text_bottom {
            body_text_en
            body_text_de
          }
        }
      }
      assets(
        where: {
          subtype_in: [
            "dxf"
            "3ds"
            "dwg"
            "skp"
            "root.productsheet."
            "root.pressrelease."
            "root.manual.gebrauchsanleitung."
            "root.pflege."
            "root.zerti."
            "picture.certificate."
            "picture.clipped."
            "picture.pdp-cutout."
            "picture.ambiance."
          ]
        }
        sort: "sorting:asc"
      ) {
        #where: { channels_in: $mediaOutputChannel },
        id
        type
        subtype
        sorting
        channels
        file {
          id
          url
          formats
          name
          caption
          alternativeText
          ext
          mime
          width
          height
          size
        }
      }
    }
  }
  ${QUERY_ASSETS}
  ${FRAGMENT_DYNAMIC_ZONES}
`;
export const QUERY_PRODUCT_VARIANTS = gql`
  query VariantsProductDetails($productVariants: [ID]!) {
    productVariants(where: { id_in: $productVariants }) {
      id
      name
      dimensions
      # materials {
      #   name_en
      #   name_de
      #   material_category {
      #     name_en
      #     name_de
      #     type
      #   }
      #   material_colors {
      #     name_en
      #     name_de
      #     assets {
      #       id
      #       file {
      #         url
      #         width
      #         height
      #         alternativeText
      #         formats
      #       }
      #     }
      #   }
      # }

      # material_colors {
      #   name_en
      #   name_de
      #   assets {
      #     id
      #     file {
      #       url
      #       width
      #       height
      #       alternativeText
      #       formats
      #     }
      #   }
      #   material {
      #     name_en
      #     name_de
      #     material_category {
      #       name_en
      #       name_de
      #       type
      #     }
      #   }
      # }
      assets {
        ...assetsFields
      }
    }
  }
  ${QUERY_ASSETS}
`;

export const QUERY_PRODUCT_SERIES = gql`
  query ProductSeries(
    $productSeriesId: ID!
    $productId: ID!
    $withFilters: Boolean! = true
    $outputChannel: String! = "de_DE"
  ) {
    products(
      where: { product_series: $productSeriesId, id_ne: $productId, channels_in: $outputChannel }
      limit: 3
      sort: "ranking:asc"
    ) {
      ...productCardFields
    }
  }
  ${FRAGMENT_PRODUCT_CARD}
`;

export const QUERY_PRODUCT_RELATED = gql`
  query RelatedProducts(
    $productSeriesId: ID!
    $productCategoryId: ID!
    $productId: ID!
    $withFilters: Boolean! = true
    $outputChannel: String! = "de_DE"
  ) {
    products(
      where: {
        product_categories: $productCategoryId
        id_ne: $productId
        product_series_ne: $productSeriesId
        channels_in: $outputChannel
      }
      limit: 3
      sort: "ranking:asc"
    ) {
      ...productCardFields
    }
  }
  ${FRAGMENT_PRODUCT_CARD}
`;
